import type { Brand } from './types';

/** System Labs portal brand (default flavor). Values match the strings
 *  that were inlined before `@brand` existed. */
export const brand: Brand = {
  name: 'System Labs',
  supportEmail: 'support@systemlabs.com',
  stripeMerchantSurfaces: true,
  careTeamMessaging: true,
  accountClinician: true,
  productImages: true,
  storeProductImageBase: null,
  authStorageKey: 'system.portal.auth',
  storageKeyPrefix: 'system.',
  planLengthSwitch: true,
  cycleDayPlanLabels: true,
  markStepThumbnails: true,
  treatmentsTitle: 'Your stack',
  membershipName: 'System Membership',
  namedReviewer: true,
  appointmentsCopy: true,
  pendingOrderCancelNotice: false,
  planOrderPayments: false,
  storefrontTreatments: false,
  stableSkeletons: false,
  prettyProfileValues: false,
  storefrontOnboarding: false,
  storefrontAccount: false,
  orderReviewSteps: false,
  storefrontSignIn: false,
  iconTitles: true,
  taskImages: {
    id: { src: '/icons/system_id_placeholder.png' },
    intake: { src: '/icons/system_intake_placeholder.png' },
  },
};

export default brand;
